const state = {
  costCenter: ""
};

const getters = {
  getCostCenter: state => {
    return state.costCenter;
  }
};

const mutations = {
  setCostCenter: (state, payload) => {
    state.costCenter = payload;
  }
};

const actions = {
  setCostCenter: ({ commit }, payload) => {
    commit("setCostCenter", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
